/**
 * Propagation status for tenant-initiated actions that require automation to
 * roll out to customer infrastructure (PXE menu, public IP, future SSH-key /
 * network-ACL propagation, etc.). The portal records intent immediately and
 * defaults to `pending`; a later verification loop - automated, or staff acting
 * manually in the early semi-manual phase - flips it to `verified` (surfaced as
 * "Propagated") or `failed`. Shared so the client renders the same vocabulary
 * the server stores. See PE-924.
 */
export type PropagationStatus = "pending" | "verified" | "failed";

export const PROPAGATION_STATUSES: readonly PropagationStatus[] = ["pending", "verified", "failed"];

/**
 * Customer-facing labels. `verified` reads as "Propagated" - the config has been
 * picked up and applied to infrastructure by automation (or staff) - which is
 * clearer to a customer than the internal "verified".
 */
export const PROPAGATION_STATUS_LABEL: Record<PropagationStatus, string> = {
  pending: "Pending",
  verified: "Propagated",
  failed: "Failed",
};
